import React, { useContext } from 'react'
import RSRLDoughnut from './RSRLDoughnut'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlIndicateursXlsxFormations.edges
  const page = props.page
  const slug = useContext(AccordionContext)

  let labels = edges.map((row, i) => row.node.LABEL)
  let values = edges.map((row, i) => row.node.NB_FORMATION)
  let backgroundColor = edges.map((row, i) => row.node.BACKGROUND_COLOR)



  return (
    <div className="text-content accordion-content accordion-table">
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <RSRLDoughnut
        labels={labels}
        values={values}
        backgroundColor={backgroundColor}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlIndicateursXlsxFormations {
      edges {
        node {
          LABEL
          NB_FORMATION
          BACKGROUND_COLOR
        }
      }
    }
  }
`
